export default __webpack_public_path__ + "static/media/check-all.364f76fb.svg";